// Load Google Analytics (gtag) only in production
export function loadGtag() {
  try {
    if (process.env.NODE_ENV === "production") {
      const GA_ID = "G-G7K8K69Q7E"; // keep the existing measurement id

      // inject gtag script
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(script);

      // initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", GA_ID);
    }
  } catch (e) {
    // swallow errors to avoid crashing the app in any environment
    // eslint-disable-next-line no-console
    console.error("Error loading gtag:", e);
  }
}
